<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col-1-1">
    </div>
    <div class="col-2"></div>
    <div class="col-3 bold">
      Huidige periode
    </div>
    <div class="col-4 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="convertibleBorrowingsNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende converteerbare leningen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="debenturesOtherPrivateLoansNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende obligatieleningen, pandbrieven en andere leningen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(2)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="financeLeaseLiabilitiesNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende financiële leaseverplichtingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(3)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="payablesBanksNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende schulden aan banken</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(4)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="advancesReceivedNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende ontvangen vooruitbetalingen op bestellingen voor zover niet reeds op
            actiefposten in mindering gebracht</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(5)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="tradePayablesNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende schulden aan leveranciers en handelskredieten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(6)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="billsExchangeChequesPayableNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende te betalen wissels en cheques</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(7)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="payablesGroupCompaniesNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Langlopende schulden aan groepsmaatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(8)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="payablesShareholdersParticipatingInterestsNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px; ">Langlopende schulden aan rechtspersonen en vennootschappen die een deelneming
            hebben in de {{ isRechtspersoon ? "rechtspersoon of waarin de rechtspersoon" : "entiteit of waarin de entiteit"}} een deelneming heeft</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(9)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="payablesOtherAffiliatedCompaniesNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Langlopende schulden aan overige verbonden maatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(10)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="taxesSocialSecurityContributionsPayableNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende schulden ter zake van belastingen en premies van sociale
            verzekeringen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(11)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="taxPayablesNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Belastingverplichtingen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(12)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="pensionPayablesNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende schulden ter zake van pensioenen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(13)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="oldAgeObligationFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Oudedagsverplichting</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(14)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="negativeGoodwillFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Negatieve goodwill</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(15)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="payablesOtherNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende overige schulden</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(16)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="accrualsAndDeferredIncomeNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende overlopende passiva</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(17)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="liabilitiesNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px"><b>Totaal van langlopende schulden</b></p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="liabilitiesNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende schulden</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.liabilitiesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(19)">
          {{ this.liabilitiesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="subordinatedLiabilitiesNoncurrentDisclosureFg"
        *ngIf="!this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende achtergestelde schulden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.subordinatedLiabilitiesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(20)">
          {{ this.subordinatedLiabilitiesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="subordinatedLiabilitiesNoncurrentNatureDescriptionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de aard van de achterstelling van langlopende schulden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(21)">
          {{ this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="convertibleBorrowingsNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende converteerbare leningen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.convertibleBorrowingsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(22)">
          {{ this.convertibleBorrowingsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="debenturesOtherPrivateLoansNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende obligatieleningen, pandbrieven en andere
          leningen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.debenturesOtherPrivateLoansNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(23)">
          {{ this.debenturesOtherPrivateLoansNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="financeLeaseLiabilitiesNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over financiële leaseverplichtingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.financeLeaseLiabilitiesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(24)">
          {{ this.financeLeaseLiabilitiesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="financeLeasesImportantConditionsFg" *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Belangrijkste bepalingen van financiële leases</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.financeLeasesImportantConditionsFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(25)">
          {{ this.financeLeasesImportantConditionsFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="mainPurposeFinancialLeaseLessorDescriptionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de belangrijkste bepalingen van financiële leases in de jaarrekening
          van de lessor</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.mainPurposeFinancialLeaseLessorDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(26)">
          {{ this.mainPurposeFinancialLeaseLessorDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="legalPersonNotALegalOwnerDescriptionFg" *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Beschrijving van de rechtspersoon die geen juridisch eigenaar is op grond van artikel
            2:366 lid 2 BW</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.legalPersonNotALegalOwnerDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(27)">
            {{ this.legalPersonNotALegalOwnerDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="payablesBanksNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende schulden aan banken</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.payablesBanksNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(28)">
          {{ this.payablesBanksNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="advancesReceivedNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende ontvangen vooruitbetalingen op bestellingen voor
          zover niet reeds op actiefposten in mindering gebracht</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.advancesReceivedNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(29)">
          {{ this.advancesReceivedNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="tradePayablesNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende schulden aan leveranciers en
          handelskredieten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.tradePayablesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(30)">
          {{ this.tradePayablesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="billsExchangeChequesPayableNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende te betalen wissels en cheques</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.billsExchangeChequesPayableNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(31)">
          {{ this.billsExchangeChequesPayableNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="payablesGroupCompaniesNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over langlopende schulden aan groepsmaatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.payablesGroupCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(32)">
            {{ this.payablesGroupCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende schulden aan rechtspersonen en vennootschappen
          die een deelneming hebben in de {{ isRechtspersoon ? "rechtspersoon of waarin de rechtspersoon" : "entiteit of waarin de entiteit"}} een deelneming heeft</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(33)">
          {{ this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over langlopende schulden aan overige verbonden
            maatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(34)">
            {{ this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende schulden ter zake van belastingen en premies van
          sociale verzekering</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(35)">
          {{ this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="taxPayablesNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over belastingverplichtingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.taxPayablesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(36)">
            {{ this.taxPayablesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="pensionPayablesNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende schulden ter zake van pensioenen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.pensionPayablesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(37)">
          {{ this.pensionPayablesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="oldAgeObligationDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over oudedagsverplichtingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.oldAgeObligationDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(38)">
          {{ this.oldAgeObligationDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="negativeGoodwillDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over negatieve goodwill</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.negativeGoodwillDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(39)">
          {{ this.negativeGoodwillDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="negativeGoodwillFutureLossesDescriptionFg" *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de toekomstige verliezen waarop de negatieve goodwill betrekking
          heeft</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.negativeGoodwillFutureLossesDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(40)">
          {{ this.negativeGoodwillFutureLossesDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de post van de winst-en-verliesrekening waaronder de bate in verband
          met negatieve goodwill is verantwoord</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(41)">
          {{ this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de periode waarin de negatieve goodwill ten gunste van de
          winst-en-verliesrekening wordt gebracht</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(42)">
          {{ this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="payablesOtherNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende overige schulden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.payablesOtherNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(43)">
          {{ this.payablesOtherNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="accrualsAndDeferredIncomeNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende overlopende passiva</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.accrualsAndDeferredIncomeNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(44)">
          {{ this.accrualsAndDeferredIncomeNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="liabilitiesSecuredStatementFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Opgave van de schulden waarvoor zakelijke zekerheid is gesteld en in welke vorm dat is
          geschied</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.liabilitiesSecuredStatementFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(45)">
          {{ this.liabilitiesSecuredStatementFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="formCollateralProvidedTotalDebtsDescriptionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de vorm waarin zekerheid voor het totaal van de schulden is
          verstrekt</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.formCollateralProvidedTotalDebtsDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(46)">
          {{ this.formCollateralProvidedTotalDebtsDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="liabilitiesNoncurrentMaturityDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over de looptijd van langlopende schulden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.liabilitiesNoncurrentMaturityDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(47)">
          {{ this.liabilitiesNoncurrentMaturityDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="effectiveInterestRateOnLongtermDebtDisclosureFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over de effectieve rentevoet van langlopende schulden in geval
          van (dis)agio, als gevolg waarvan effectieve rente meer dan fractioneel hoger of lager is dan het
          jaarpercentage</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.effectiveInterestRateOnLongtermDebtDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(48)">
          {{ this.effectiveInterestRateOnLongtermDebtDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="liabilitiesMaturityInterestRateDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de rentevoet over de schulden met een looptijd langer dan een jaar</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.liabilitiesMaturityInterestRateDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(49)">
          {{ this.liabilitiesMaturityInterestRateDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over de langlopende schulden waarvoor de rechtspersoon zich, al
            dan niet voorwaardelijk, heeft verbonden tot het bezwaren of niet bezwaren van goederen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(50)">
            {{ this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="liabilitiesNoncurrentImmediateExigibilityDescriptionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de belangrijkste voorwaarden ten aanzien van de opeisbaarheid van de
          schulden die bij benadering direct of op korte termijn opeisbaar worden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.liabilitiesNoncurrentImmediateExigibilityDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(51)">
          {{ this.liabilitiesNoncurrentImmediateExigibilityDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form
    [formGroup]="bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg"
    *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de belangrijkste voorwaarden en bepalingen die op balansdatum of na
          balansdatum maar voor het moment van opmaken van de jaarrekening nog niet in werking zijn getreden maar dicht
          zijn benaderd</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(52)">
          {{ this.bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="moneyOrSharesRedeemableLoansConditionsConversionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Voorwaarden van conversie voor in geld of in aandelen aflosbare leningen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.moneyOrSharesRedeemableLoansConditionsConversionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(53)">
          {{ this.moneyOrSharesRedeemableLoansConditionsConversionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="sharesRedeemableLoansConditionsConversionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Voorwaarden van conversie voor in geld of in aandelen aflosbare leningen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.sharesRedeemableLoansConditionsConversionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(54)">
          {{ this.sharesRedeemableLoansConditionsConversionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="warrantsAndWarrantsLoansConditionsConversionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Voorwaarden van conversie voor warrants en warrantleningen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.warrantsAndWarrantsLoansConditionsConversionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(55)">
          {{ this.warrantsAndWarrantsLoansConditionsConversionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="convertibleBorrowingsConditionsConversionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Voorwaarden van conversie voor converteerbare leningen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.convertibleBorrowingsConditionsConversionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(56)">
          {{ this.convertibleBorrowingsConditionsConversionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de indicering van de aard van afhankelijkheid en van de factoren in
          geval van niet vaststaande rentevoet</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(57)">
          {{ this.indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg"
        *ngIf="this.jrDataService.isLegalSizeMediumOrLarger()">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van het verloop van de rentevoet in geval van niet gelijkblijvende
          rentevoet voor resterende looptijd</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(58)">
          {{ this.progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.convertibleBorrowingsNoncurrentFg"
                                                       [title]="'langlopende converteerbare leningen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.debenturesOtherPrivateLoansNoncurrentFg"
                                                       [title]="'langlopende obligatieleningen, pandbrieven en andere leningen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.financeLeaseLiabilitiesNoncurrentFg"
                                                       [title]="'langlopende financiële leaseverplichtingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.payablesBanksNoncurrentFg"
                                                       [title]="'langlopende schulden aan banken'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 5">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.advancesReceivedNoncurrentFg"
                                                       [title]="'langlopende ontvangen vooruitbetalingen op bestellingen voor zover niet reeds op actiefposten in mindering gebracht'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.tradePayablesNoncurrentFg"
                                                       [title]="'langlopende schulden aan leveranciers en handelskredieten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 7">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.billsExchangeChequesPayableNoncurrentFg"
                                                       [title]="'langlopende te betalen wissels en cheques'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 8">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.payablesGroupCompaniesNoncurrentFg"
                                                       [title]="'langlopende schulden aan groepsmaatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 9">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.payablesShareholdersParticipatingInterestsNoncurrentFg"
                                                       [title]="`langlopende schulden aan rechtspersonen en vennootschappen die een deelneming hebben in de ${isRechtspersoon ? 'rechtspersoon of waarin de rechtspersoon' : 'entiteit of waarin de entiteit'} een deelneming heeft`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 10">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.payablesOtherAffiliatedCompaniesNoncurrentFg"
                                                       [title]="'langlopende schulden aan overige verbonden maatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 11">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.taxesSocialSecurityContributionsPayableNoncurrentFg"
                                                       [title]="'langlopende schulden ter zake van belastingen en premies van sociale verzekeringen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 12">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.taxPayablesNoncurrentFg"
                                                       [title]="'belastingverplichtingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 13">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.pensionPayablesNoncurrentFg"
                                                       [title]="'langlopende schulden ter zake van pensioenen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 14">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.oldAgeObligationFg"
                                                       [title]="'oudedagsverplichting'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 15">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.negativeGoodwillFg"
                                                       [title]="'negatieve goodwill'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 16">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.payablesOtherNoncurrentFg"
                                                       [title]="'langlopende overige schulden'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 17">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.accrualsAndDeferredIncomeNoncurrentFg"
                                                       [title]="'langlopende overlopende passiva'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 19">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.liabilitiesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 20">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.subordinatedLiabilitiesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende achtergestelde schulden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 21">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg"
                                                               [title]="'Beschrijving van de aard van de achterstelling van langlopende schulden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 22">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.convertibleBorrowingsNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende converteerbare leningen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 23">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.debenturesOtherPrivateLoansNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende obligatieleningen, pandbrieven en andere leningen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 24">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.financeLeaseLiabilitiesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over financiële leaseverplichtingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 25">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.financeLeasesImportantConditionsFg"
                                                               [title]="'Beschrijving van de belangrijkste bepalingen van financiële leases'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 26">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.mainPurposeFinancialLeaseLessorDescriptionFg"
                                                               [title]="'Beschrijving van de belangrijkste bepalingen van financiële leases in de jaarrekening van de lessor'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 27">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.legalPersonNotALegalOwnerDescriptionFg"
                                                               [title]="'Beschrijving van de rechtspersoon die geen juridisch eigenaar is op grond van artikel 2:366 lid 2 BW'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 28">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.payablesBanksNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden aan banken'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 29">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.advancesReceivedNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende ontvangen vooruitbetalingen op bestellingen voor zover niet reeds op actiefposten in mindering gebracht'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 30">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.tradePayablesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden aan leveranciers en handelskredieten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 31">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.billsExchangeChequesPayableNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende te betalen wissels en cheques'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 32">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.payablesGroupCompaniesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden aan groepsmaatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 33">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg"
                                                               [title]="`Informatieverschaffing over langlopende schulden aan rechtspersonen en vennootschappen die een deelneming hebben in de ${isRechtspersoon ? 'rechtspersoon of waarin de rechtspersoon' : 'entiteit of waarin de entiteit'} een deelneming heeft`"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 34">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden aan overige verbonden maatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 35">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden ter zake van belastingen en premies van sociale verzekering'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 36">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.taxPayablesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over belastingverplichtingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 37">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.pensionPayablesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende schulden ter zake van pensioenen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 38">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.oldAgeObligationDisclosureFg"
                                                               [title]="'Informatieverschaffing over oudedagsverplichtingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 39">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.negativeGoodwillDisclosureFg"
                                                               [title]="'Informatieverschaffing over negatieve goodwill'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 40">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.negativeGoodwillFutureLossesDescriptionFg"
                                                               [title]="'Beschrijving van de toekomstige verliezen waarop de negatieve goodwill betrekking heeft'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 41">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg"
                                                               [title]="'Beschrijving van de post van de winst-en-verliesrekening waaronder de bate in verband met negatieve goodwill is verantwoord'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 42">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg"
                                                               [title]="'Beschrijving van de periode waarin de negatieve goodwill ten gunste van de winst-en-verliesrekening wordt gebracht'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 43">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.payablesOtherNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende overige schulden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 44">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.accrualsAndDeferredIncomeNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende overlopende passiva'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 45">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.liabilitiesSecuredStatementFg"
                                                               [title]="'Opgave van de schulden waarvoor zakelijke zekerheid is gesteld en in welke vorm dat is geschied'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 46">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.formCollateralProvidedTotalDebtsDescriptionFg"
                                                               [title]="'Beschrijving van de vorm waarin zekerheid voor het totaal van de schulden is verstrekt'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 47">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.liabilitiesNoncurrentMaturityDisclosureFg"
                                                               [title]="'Informatieverschaffing over de looptijd van langlopende schulden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 48">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.effectiveInterestRateOnLongtermDebtDisclosureFg"
                                                               [title]="'Informatieverschaffing over de effectieve rentevoet van langlopende schulden in geval van (dis)agio, als gevolg waarvan effectieve rente meer dan fractioneel hoger of lager is dan het jaarpercentage'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 49">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.liabilitiesMaturityInterestRateDescriptionFg"
                                                               [title]="'Beschrijving van de rentevoet over de schulden met een looptijd langer dan een jaar'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 50">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg"
                                                               [title]="'Informatieverschaffing over de langlopende schulden waarvoor de rechtspersoon zich, al dan niet voorwaardelijk, heeft verbonden tot het bezwaren of niet bezwaren van goederen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 51">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.liabilitiesNoncurrentImmediateExigibilityDescriptionFg"
                                                               [title]="'Beschrijving van de belangrijkste voorwaarden ten aanzien van de opeisbaarheid van de schulden die bij benadering direct of op korte termijn opeisbaar worden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 52">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg"
                                                               [title]="'Beschrijving van de belangrijkste voorwaarden en bepalingen die op balansdatum of na balansdatum maar voor het moment van opmaken van de jaarrekening nog niet in werking zijn getreden maar dicht zijn benaderd'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 53">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.moneyOrSharesRedeemableLoansConditionsConversionFg"
                                                               [title]="'Voorwaarden van conversie voor in geld of in aandelen aflosbare leningen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 54">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.sharesRedeemableLoansConditionsConversionFg"
                                                               [title]="'Voorwaarden van conversie voor in geld of in aandelen aflosbare leningen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 55">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.warrantsAndWarrantsLoansConditionsConversionFg"
                                                               [title]="'Voorwaarden van conversie voor warrants en warrantleningen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 56">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.convertibleBorrowingsConditionsConversionFg"
                                                               [title]="'Voorwaarden van conversie voor converteerbare leningen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 57">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg"
                                                               [title]="'Beschrijving van de indicering van de aard van afhankelijkheid en van de factoren in geval van niet vaststaande rentevoet'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 58">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg"
                                                               [title]="'Beschrijving van het verloop van de rentevoet in geval van niet gelijkblijvende rentevoet voor resterende looptijd'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
